import { WorkingInterview } from '~/actions/PermanentJobs';
import { IPermanentJobState, IWorkingInterview } from './States';
import {
  TAppendWorkingInterviewsAction,
  TCreateWorkingInterviewsAction,
  TDeleteWorkingInterviewAction,
  TEditWorkingInterviewAction,
  TClearWorkingInterviewsAction,
  TPermanentJobAction,
} from './Types';
import { v4 } from 'uuid';

export const INITIAL_STATE: IPermanentJobState = {
  workingInterviews: {},
};

export default (
  state: IPermanentJobState = INITIAL_STATE,
  action: TPermanentJobAction,
): IPermanentJobState => {
  switch (action.type) {
    case WorkingInterview.APPEND: {
      const { payload } = action as TAppendWorkingInterviewsAction;
      const { jobPostingId, data } = payload;

      if (!state.workingInterviews[jobPostingId]) {
        return state;
      }

      const newData = [
        ...state.workingInterviews[jobPostingId],
        ...data.dates.map(
          (it) =>
            ({
              breakTime: data.breakTime,
              date: it.toISOString(),
              hourlyRate: data.hourlyRate,
              hoursArrival: data.hoursArrival,
              hoursDeparture: data.hoursDeparture,
              isAssistedHygiene: data.isAssistedHygiene,
              id: v4(),
              isPaidBreakTime: data.isPaidBreakTime,
              specialty: data.specialty,
            }) as IWorkingInterview,
        ),
      ];

      return {
        ...state,
        workingInterviews: {
          ...state.workingInterviews,
          [jobPostingId]: newData,
        },
      };
    }
    case WorkingInterview.CREATE: {
      const { payload } = action as TCreateWorkingInterviewsAction;
      const { postingId, workingInterviews: data } = payload;

      return {
        ...state,
        workingInterviews: {
          ...state.workingInterviews,
          [postingId]: data.dates.map(
            (it) =>
              ({
                breakTime: data.breakTime,
                date: it.toISOString(),
                hourlyRate: data.hourlyRate,
                hoursArrival: data.hoursArrival,
                hoursDeparture: data.hoursDeparture,
                isAssistedHygiene: data.isAssistedHygiene,
                id: v4(),
                isPaidBreakTime: data.isPaidBreakTime,
                specialty: data.specialty,
              }) as IWorkingInterview,
          ),
        },
      };
    }
    case WorkingInterview.DELETE: {
      const { payload } = action as TDeleteWorkingInterviewAction;
      const { id, jobPostingId } = payload;

      if (!state.workingInterviews[jobPostingId]) {
        return state;
      }

      const newInterviews = state.workingInterviews[jobPostingId].filter((it) => it.id !== id);

      return {
        ...state,
        workingInterviews: {
          ...state.workingInterviews,
          [jobPostingId]: newInterviews,
        },
      };
    }
    case WorkingInterview.EDIT: {
      const { payload } = action as TEditWorkingInterviewAction;
      const { postingId, workingInterview: data } = payload;

      if (!state.workingInterviews[postingId]) {
        return state;
      }

      const current = [...state.workingInterviews[postingId]];
      const idx = current.findIndex((it) => it.id === data.id);

      if (idx === -1) return state;

      current[idx] = {
        ...current[idx],
        breakTime: data.breakTime,
        hourlyRate: data.hourlyRate,
        hoursArrival: data.hoursArrival,
        hoursDeparture: data.hoursDeparture,
        isAssistedHygiene: data.isAssistedHygiene,
        isPaidBreakTime: data.isPaidBreakTime,
        specialty: data.specialty,
      };

      return {
        ...state,
        workingInterviews: {
          ...state.workingInterviews,
          [postingId]: current,
        },
      };
    }
    case WorkingInterview.CLEAR: {
      const { payload } = action as TClearWorkingInterviewsAction;
      const { postingId } = payload;

      return {
        ...state,
        workingInterviews: {
          ...state.workingInterviews,
          [postingId]: [],
        },
      };
    }
    default:
      return state;
  }
};
